import React, { useEffect, useState } from 'react'
import worker from "../../helpers/worker";

const timerWorker = new Worker(worker);

const Timer = (props: any) => {
  const [seconds, setSeconds] = useState(0)
  const [minutes, setMinutes] = useState(props.time || 5)

  function updateTime1() {
    if (minutes == 0 && seconds == 0) {
      //reset
      setSeconds(0)
      setMinutes(0)
      props.timerEnd(true)
      timerWorker.postMessage({ turn: "off" });
    }
    // else if (minutes == 4 && seconds == 20) {
    //   props.smsChange ?  props.smsChange(true) : false
    //   setMinutes((minutes) => minutes - 1)
    //   setSeconds(seconds => seconds - 1)
    // }
    else {
      if (seconds == 0) {
        setMinutes((minutes) => minutes - 1)
        setSeconds(59)
      } else {
        setSeconds((seconds) => seconds - 1)
      }
    }
  }

  useEffect(() => {
    if (props.reset) {
      setMinutes(props.time || 5);
      setSeconds(0);
    }

    // const token = setTimeout(updateTime, 1000)

    timerWorker.onmessage = ({ data: { time } }) => {
      if(time % 10 === 0)
        updateTime1();
    };

    // console.log('loaded')
    // return function cleanUp() {
      // startWebWorkerTimer()
      // clearTimeout(token)
    // }
  }, [seconds, minutes])

  // useEffect(() => {
  //   if (props?.buttonClicked !== undefined && props?.buttonClicked !== 0) {
  //     TriggeredFunc()
  //   }
  // }, [props?.buttonClicked])

  useEffect(() => {
    // if (props?.buttonClicked !== undefined && props?.buttonClicked !== 0) {
      startWebWorkerTimer()
    // }
  }, [props?.buttonClicked])

  // const TriggeredFunc = () => {
  //   timerWorker.postMessage({ turn: "off" });
  //   setMinutes(5);
  //   setSeconds(0);
  // }

  const startWebWorkerTimer = () => {
    timerWorker.postMessage({ turn: "off" });
    timerWorker.postMessage({ turn: "on" });
    setMinutes(props.time || 5);
      setSeconds(0);
  };

  // useEffect(() => {
  //   console.log("isledi reset");
  //   setMinutes(5);
  //   setSeconds(0);
  //   // if(props.reset) {
  //   //   const token = setTimeout(updateTime, 1000)
  //   //
  //   //   // console.log('loaded')
  //   //   return function cleanUp() {
  //   //     clearTimeout(token)
  //   //   }
  //   // }
  // }, [props.reset])

  return (
    <>
      <span style={props.style}>
        0{minutes}:{seconds == 0 || seconds < 10 ? `0${seconds}` : +seconds}
      </span>
    </>
  )
}
export default Timer
